import authenticatedAxiosInstance from '../axios/axios-authorized';

export const getHomePageDataFromWebflow = async () => {
  return (await authenticatedAxiosInstance.axios.get(`/homepage/data/home-page-data-from-webflow`))
    .data;
};
